// player/bookings/BookingNew/api/queries/getBookingSavedCards.ts
import { gql } from '@apollo/client/core'

import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'

export const GET_BOOKING_SAVED_CARDS_QUERY = gql`
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}
  ${SERVER_ERROR}

  query getBookingSavedCards($userId: String!) {
    getSavedCards(input: { userId: $userId }) {
      ... on GetSavedCardsOutput {
        savedCards {
          stripeCardId
          brand
          last4
          expMonth
          expYear
        }
      }
      ...UnauthenticatedError
      ...UnauthorizedError
      ...ServerError
    }
  }
`
